import { User, AccountStatus, BelongsTo } from '../types';

export const initialUser: User = {
  id: '',
  email: '',
  firstName: '',
  lastName: '',
  phoneNumber: '',
  canTrade: true,
  accountStatus: AccountStatus.DEACTIVATED,
  belongsTo: BelongsTo.CLIENT,
  yardCompanyEmployee: {
    yardCompanyId: '',
    role: '',
    yardCompany: { legalName: '' },
  },
  yardEmployee: {
    yardId: '',
    role: '',
    yard: { name: '' },
  },
  clientEmployee: {
    clientId: '',
    role: '',
    client: { code: '', legalName: '', category: 'NONE' },
  },
  createdAt: new Date(),
  updatedAt: new Date(),
  type: 'CLIENT_DISPATCHER',
};
